import { 
  faBriefcase, 
  faSmile, 
  faBolt, 
  faPalette, 
  faGraduationCap,
  faChartLine,
  faLaugh
} from '@fortawesome/free-solid-svg-icons';
 
export interface BotPersonality {
  name: string;
  icon: any;
  description: string;
  examples: {
    greeting?: string;
    answer: string;
  };
}

export const BOT_PERSONALITIES: Record<string, BotPersonality> = {
  professional: {
    name: "Professional",
    icon: faBriefcase,
    description: "Formal, concise, business-focused",
    examples: {
      greeting: "Good day. How may I assist you today?",
      answer: "Our services include comprehensive solutions for your business needs. Please specify which area you'd like to explore."
    }
  },
  
  friendly: {
    name: "Friendly & Warm",
    icon: faSmile, 
    description: "Conversational, approachable, engaging",
    examples: {
      greeting: "Hi there! 👋 Welcome! I'm here to help with anything you need.",
      answer: "I'd love to help you with that! Let me share what we offer - I think you'll find something perfect for your needs."
    }
  },
  
  concise: {
    name: "Concise & Direct",
    icon: faBolt,
    description: "Brief, to-the-point responses",
    examples: {
      greeting: "Hello. How can I help?",
      answer: "• Service A: $99/mo\n• Service B: $149/mo\n• Service C: Custom pricing\n\nNeed details?"
    }
  },
  
  educational: {
    name: "Educational",
    icon: faGraduationCap,
    description: "Teacher-like, detailed explanations", 
    examples: {
      greeting: "Welcome! I'm here to help you understand everything about our services.",
      answer: "Let me explain how this works step-by-step. First, it's important to understand the foundation..."
    }
  },
  
  sales_focused: {
    name: "Sales Focused",
    icon: faChartLine,
    description: "Persuasive, benefit-oriented",
    examples: {
      greeting: "Welcome! Ready to transform your business? I'm here to show you how!",
      answer: "This is exactly what successful businesses like yours need! Here's how it will boost your results..."
    }
  },
  
  humorous: {
    name: "Humorous & Witty",
    icon: faLaugh,
    description: "Fun, entertaining, light-hearted",
    examples: {
      greeting: "Hey there! 😄 Welcome to the fun zone! I promise to help AND entertain!",
      answer: "Oh, you want to know about our services? Buckle up, this is going to be more fun than a tax refund! 🎉"
    }
  }
};